import { atom } from 'recoil'

import getIntl from 'Helpers/intl'
import type { PageStateType } from 'Types/state'

export const pageState = atom<PageStateType>({
  key: 'pageState',
  default: {
    title: '',
    status: 'initial',
    loading: false,
    fetching: false,
    errorMessage: undefined,
  },
})

export const loaderUpdater =
  (loading: boolean) =>
  (prev: PageStateType): PageStateType => ({
    ...prev,
    loading,
  })

export const fetcherUpdater =
  (fetching: boolean) =>
  (prev: PageStateType): PageStateType => ({
    ...prev,
    fetching,
  })

export const statusUpdater =
  (status: PageStateType['status']) =>
  (prev: PageStateType): PageStateType => ({
    ...prev,
    status,
  })

export const errorUpdater = (prev: PageStateType): PageStateType => ({
  ...prev,
  status: 'error',
  loading: false,
  fetching: false,
  errorMessage: getIntl().formatMessage({
    id: 'Load.Alerts.ErrorGeneric',
  }),
})
